module.exports = __webpack_public_path__ + "img/mobile-assets-01.9910d307.png";